function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.182 0h-6.546a.818.818 0 000 1.636h4.57l-8.42 8.422a.818.818 0 001.156 1.157l8.422-8.422v4.57a.818.818 0 001.636 0V.819A.818.818 0 0017.182 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.91 8.182a.818.818 0 00-.82.818v7.364H1.637V4.909H9a.818.818 0 000-1.636H.818A.818.818 0 000 4.09v13.09c0 .453.366.819.818.819H13.91a.818.818 0 00.818-.818V9a.818.818 0 00-.818-.818z"
}));

function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    className: "icon"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8dGl0bGU+CiAgICBFeHRlcm5hbCBsaW5rCiAgPC90aXRsZT4KICA8ZyBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICA8cGF0aCBkPSJNMTcuMTgyIDBoLTYuNTQ2YS44MTguODE4IDAgMDAwIDEuNjM2aDQuNTdsLTguNDIgOC40MjJhLjgxOC44MTggMCAwMDEuMTU2IDEuMTU3bDguNDIyLTguNDIydjQuNTdhLjgxOC44MTggMCAwMDEuNjM2IDBWLjgxOUEuODE4LjgxOCAwIDAwMTcuMTgyIDB6Ii8+CiAgICA8cGF0aCBkPSJNMTMuOTEgOC4xODJhLjgxOC44MTggMCAwMC0uODIuODE4djcuMzY0SDEuNjM3VjQuOTA5SDlhLjgxOC44MTggMCAwMDAtMS42MzZILjgxOEEuODE4LjgxOCAwIDAwMCA0LjA5djEzLjA5YzAgLjQ1My4zNjYuODE5LjgxOC44MTlIMTMuOTFhLjgxOC44MTggMCAwMC44MTgtLjgxOFY5YS44MTguODE4IDAgMDAtLjgxOC0uODE4eiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgExternalLink as ReactComponent };